// @owners { team: patients }
import { Platform } from 'react-native';

// helper functions to get OS
export const getPlatformOS = () => {
  return Platform.OS;
};
